export * from "./GetQuoteSupport";
export { default } from "./GetQuoteSupport";
